import AddSaleschannelInfoModal from './add-saleschannel-info-modal.vue'
export default AddSaleschannelInfoModal
